import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberCaratright = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M25.24 19.355a1 1 0 0 1 1.41-.108l14 11.994a1 1 0 0 1 .001 1.518l-14 12.006a1 1 0 0 1-1.302-1.518L38.463 32 25.35 20.765a1 1 0 0 1-.108-1.41",
		clipRule: "evenodd"
	})
});
export default SvgCyberCaratright;
